import CloudImg from "public/ztna/cloudOnPrem.svg";
import SecImg from "public/ztna/security.svg";
import ZtnaImg from "public/ztna/ztna.svg";

export const ADVANTAGES_CONSTANTS = [
  {
    image: ZtnaImg,
    title: "Zero Trust Network Access (ZTNA)",
    text: "Leveraging technologies from Fortinet and Palo Alto Networks, aligned with Gartner’s SASE framework.",
  },
  {
    image: CloudImg,
    title: "Cloud and On-Prem VPN Solutions",
    text: "Powered by Cisco and Juniper Networks to support secure, scalable access across environments.",
  },
  {
    image: SecImg,
    title: "Advanced Edge Firewall Security",
    text: "Integrated seamlessly with Fortinet’s next-gen firewalls for deep packet inspection and adaptive threat prevention.",
  },
  {
    image: SecImg,
    title: "Secure Access Service Edge (SASE)",
    text: "Designed in line with architectures supported by  Check Point, enabling secure cloud-native access at scale.",
  },
];
